export default function initOpenClose() {
  Alpine.data('openClose', () => ({
    open: false,
    openDialog() {
      this.open = true;
      document.body.style.overflowY = 'hidden';
    },
    closeDialog() {
      this.open = false;
      document.body.style.overflowY = 'initial';
    },
    toggleOpen() {
      if (this.open) {
        this.closeDialog();
      } else {
        this.openDialog();
      }
    },
  }));
}
